import * as THREE from 'three';
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import { GameConfig } from '../utils/GameConfig';


export default class Tube extends THREE.Object3D {
    constructor(options) {
        super();
    }

    /** 
     * Public 
    */

    build() {
        let geometry = new THREE.CylinderGeometry(1.2, 1.2, 180, 20, 1);
        let material = new THREE.MeshLambertMaterial({
            side: THREE.DoubleSide,
            // color: GameConfig.gameColors[0].tubeColor,
            color: GameManager.gameColors.tubeColor,
            emissive : GameManager.gameColors.tubeColor,
            emissiveIntensity : .3
            // wireframe: true,
        });

        this._tube = new THREE.Mesh(geometry, material);

        //this._tube.position.y = -75;
        this._tube.position.set(0, 0, 0);

        this.add(this._tube);
    }

    changeColor() {

    }

    updateColor() {

        this._tube.material.color.set(GameManager.gameColors.tubeColor);

    }

    update(delta) {

    }
}